import { useTranslations } from 'utils';
import { createMarkup } from 'utils/createMarkup/createMarkup';

export const AstropayConditions = () => {
  const i18n = useTranslations();
  return (
    <>
      <span
        dangerouslySetInnerHTML={createMarkup(
          i18n.t('termsAndConditions.partners.astropay'),
        )}
      />
    </>
  );
};

AstropayConditions.displayName = 'AstropayConditions';
